<hfc-button type="secondary" (click)="onHelpClicked()" class="help-button">Help</hfc-button>

<hfc-logout-button></hfc-logout-button>
